import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import SocialShare from "../components/SocialShare";
import { TranslationContext } from "../contexts/TranslationContext";

const LegalNotices = () => {
  const { translations, routes } = useContext(TranslationContext);
  const url = window.location.href;
  const title = "O.A.V.L.I.T.E";
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <>
      <Helmet>
        <title>{translations.cguTitle} - O.A.V.L.I.T.E</title>
      </Helmet>
      <div className="navbar-header container-fluid px-3 mt-2 mb-5">
        <button
          className="btn btn-light bgprimary border-0 rounded-pill oavlite-text-primary px-4"
          onClick={handleBack}
        >
          {translations.back}
        </button>
        <div className="text-center pt-3 logo-wrapper" style={{}}>
          <Link to="/" className="logo-link">
            <img
              src="../images/oavlite-black.png"
              className="img-fluid mx-auto text-center d-block d-logo mb-3"
              alt="oavlite"
            />
          </Link>
          <p className="mb-2 fw-500 tagline__1">
            {translations.taglineV1}
          </p>

        </div>
        <div></div>
      </div>
      <div className="mb-3 mb-md-5">
        <div className="container-xxl px-5">
          <div className="center-content text-center">
            <h1 className="generalTermSale mb-3">{translations.generalTermSale}</h1>
          </div>
          <div className="terms-section">
            <p>{translations.para1}</p>
            <p>{translations.para2}</p>
            <p>{translations.para3}</p>
            <p>{translations.para4}</p>

            <h5>{translations.prohibitedActivites}</h5>
            <p>{translations.prohibitedPara1}</p>

            <ul className="mb-3">
              <li>{translations.prohibitedList1}</li>
              <li>{translations.prohibitedList2}</li>
              <li>{translations.prohibitedList3}</li>
              <li>{translations.prohibitedList4}</li>
              <li>{translations.prohibitedList5}</li>
              <li>{translations.prohibitedList6}</li>
              <li>{translations.prohibitedList7}</li>
              <li>{translations.prohibitedList8}</li>
              <li>{translations.prohibitedList9}</li>
              <li>{translations.prohibitedList10}</li>
              <li>{translations.prohibitedList11}</li>
              <li>{translations.prohibitedList12}</li>
              <li>{translations.prohibitedList13}</li>
              <li>{translations.prohibitedList14}</li>
              <li>{translations.prohibitedList15}</li>
              <li>{translations.prohibitedList16}</li>
              <li>{translations.prohibitedList17}</li>
            </ul>
            <h5>{translations.productService}</h5>
            <p>{translations.productServiceP1}</p>
            <h5>{translations.durationTermination}</h5>
            <p>{translations.durationTerminationP}</p>
            <h5>{translations.Payment}</h5>
            <p>{translations.PaymentP}</p>
            <h5>{translations.PrivacyPolicy}</h5>
            <p>{translations.PrivacyPolicyP}</p>
            <h5>{translations.IntellectualPropertyRights}</h5>
            <p>{translations.IntellectualPropertyRightsP}</p>
            <p>{translations.IntellectualPropertyRightsP2}</p>
            <h5>{translations.Interruptions}</h5>
            <p>{translations.InterruptionsP}</p>
            <p>{translations.Interruptionsp1}</p>
            <h5>{translations.Userdata}</h5>
            <p>{translations.UserdataP}</p>
            <h5>{translations.LimitationsLiability}</h5>
            <p>{translations.LimitationsLiabilityP}</p>
            <h5>{translations.Disclaimer}</h5>
            <p>{translations.DisclaimerP}</p>
            <h5>{translations.Compensation}</h5>
            <p>{translations.CompensationP}</p>
            <h5>{translations.Applicablelaw}</h5>
            <p>{translations.ApplicablelawP}</p>
            <h5>{translations.ChangesH}</h5>
            <p>{translations.ChangesP}</p>
          </div>
        </div>
      </div>

      <footer className="text-center">
        <SocialShare url={url} title={title} />
        <p>
          <Link className="color-primary" to={routes.legalNotices}>
            CGU
          </Link>
        </p>
      </footer>
    </>
  );
};

export default LegalNotices;
